import { useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { useAuth } from "../contexts/AuthContext";

interface Props {
  tripId: string;
  onClose: () => void;
}

export default function CreateNotificationModal({ tripId, onClose }: Props) {
  const { user } = useAuth();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [importance, setImportance] = useState<"normal" | "important">(
    "normal"
  );
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    if (!title || !message || !user) return;

    setLoading(true);

    const { error } = await supabase.from("notifications").insert({
      trip_id: tripId,
      user_id: user.id,
      title,
      message,
      importance,
    });

    setLoading(false);

    if (error) {
      console.error("❌ Fehler beim Speichern:", error.message);
    } else {
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        onClose();
      }, 1000);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center px-4">
      <div className="bg-[#161b27] rounded-2xl border border-[#2a3347] p-6 w-full max-w-md">
        <h2 className="text-sm font-semibold text-slate-100 mb-5">📣 Neue Benachrichtigung</h2>

        <label className="block text-[10px] uppercase tracking-widest text-slate-600 mb-1">Titel</label>
        <input
          className="w-full bg-[#1e2639] border border-[#2a3347] rounded-xl text-slate-100 px-3 py-2 text-sm mb-3 focus:outline-none focus:border-sky-500/50 placeholder:text-slate-600"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Titel eingeben"
        />

        <label className="block text-[10px] uppercase tracking-widest text-slate-600 mb-1">Nachricht</label>
        <textarea
          className="w-full bg-[#1e2639] border border-[#2a3347] rounded-xl text-slate-100 px-3 py-2 text-sm mb-3 focus:outline-none focus:border-sky-500/50 placeholder:text-slate-600"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Nachricht eingeben"
          rows={4}
        />

        <label className="flex items-center gap-2 mb-4 text-xs text-slate-400 cursor-pointer">
          <input
            type="checkbox"
            checked={importance === "important"}
            onChange={(e) =>
              setImportance(e.target.checked ? "important" : "normal")
            }
            className="accent-sky-500"
          />
          Diese Nachricht ist wichtig ❗
        </label>

        <div className="flex justify-end gap-2">
          <button
            className="text-xs px-3 py-1.5 rounded-full bg-[#1e2639] text-slate-400 hover:text-slate-200 transition-colors"
            onClick={onClose}
          >
            Abbrechen
          </button>
          <button
            className="text-xs px-3 py-1.5 rounded-full bg-sky-600 text-white hover:bg-sky-500 transition-colors disabled:opacity-50"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Speichern…" : success ? "✅ Gespeichert" : "Speichern"}
          </button>
        </div>
      </div>
    </div>
  );
}
